'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileIds = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _fileAttachmentKeyPaths = require('../constants/fileAttachmentKeyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getFileIds = exports.getFileIds = (0, _getIn2.default)(_fileAttachmentKeyPaths.FILE_IDS);